import { ApolloProvider } from '@apollo/client';
import React, { ReactElement } from 'react';
import { I18nProvider } from '@lingui/react';
import { ThemeProvider } from 'styled-components';
import { createTheme, GlobalStyles as GDSGlobalStyles } from '@bechtel/gds';
import { client } from '~/apollo-client';
import { ConfigProvider } from '~/hooks/use-config';
import { AppUserProvider } from '~/components/molecules/appuser/appuser-context';
import { i18n } from '@lingui/core';
import { MemoryRouter } from 'react-router';
import { messages } from '~/locales/en/messages';
import { en } from 'make-plural/plurals';

const theme = createTheme();
i18n.loadLocaleData('en', { plurals: en });
i18n.load('en', messages);
i18n.activate('en');

const customRender = (ui: ReactElement<any>) => {
  return (
    <>
      <ApolloProvider client={client}>
        <I18nProvider i18n={i18n}>
          <ThemeProvider theme={theme}>
            <ConfigProvider>
              <AppUserProvider>
                <MemoryRouter>
                  <GDSGlobalStyles />
                  {ui}
                </MemoryRouter>
              </AppUserProvider>
            </ConfigProvider>
          </ThemeProvider>
        </I18nProvider>
      </ApolloProvider>
    </>
  );
};

export { customRender as appRender };
